module.exports = __webpack_public_path__ + "img/illustration.215d8c21.png";